var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "dialog", class: { active: _vm.showDialog } },
    [
      _c(
        "div",
        {
          staticClass:
            "dialog--content dialog--medium-width u-extra-medium-padding--top",
        },
        [
          _c("h4", { staticClass: "u-extra-small-margin--bottom" }, [
            _vm._v(_vm._s(_vm.$t("generatepdf"))),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "u-extra-small-margin--bottom" }, [
            _c("strong", [
              _vm._v(
                "KW: " +
                  _vm._s(_vm.getWeek()) +
                  " (" +
                  _vm._s(_vm.getDate()) +
                  ")"
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "u-extra-small-margin--bottom" }, [
            _vm._v(_vm._s(_vm.$t("weeks.pdf.desc"))),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "grid-x grid-margin-x u-extra-small-margin--bottom",
            },
            _vm._l(_vm.kolonneItems, function (item, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass:
                    "cell small-2 form-group--check u-extra-small-margin--bottom",
                },
                [
                  _c("label", { staticClass: "align-left" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.selectedKolonne,
                          expression: "selectedKolonne",
                        },
                      ],
                      attrs: { type: "checkbox" },
                      domProps: {
                        value: item.kolonne,
                        checked: Array.isArray(_vm.selectedKolonne)
                          ? _vm._i(_vm.selectedKolonne, item.kolonne) > -1
                          : _vm.selectedKolonne,
                      },
                      on: {
                        change: function ($event) {
                          var $$a = _vm.selectedKolonne,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = item.kolonne,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                (_vm.selectedKolonne = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.selectedKolonne = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.selectedKolonne = $$c
                          }
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("i"),
                    _vm._v(
                      "\n          " + _vm._s(item.kolonne) + "\n        "
                    ),
                  ]),
                ]
              )
            }),
            0
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "button gray",
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.removeSelections.apply(null, arguments)
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("weeks.button.emptyselection")))]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "button primary",
              attrs: {
                disabled: _vm.isLoading && _vm.selectedKolonne.length > 0,
              },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.generatePdf()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("form.submit.confirm")))]
          ),
          _vm._v(" "),
          _vm.message
            ? _c(
                "p",
                {
                  staticClass:
                    "u-extra-small-margin--bottom u-extra-small-margin--top",
                  class: _vm.error ? "u-error" : "",
                },
                [_vm._v(_vm._s(_vm.message))]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "text-center u-extra-small-margin--bottom u-extra-small-margin--top",
            },
            [
              _c("v-page-loading", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isLoading,
                    expression: "isLoading",
                  },
                ],
              }),
              _vm._v(" "),
              !_vm.isLoading && _vm.success === true
                ? _c("div", [
                    _c(
                      "a",
                      {
                        staticClass: "button",
                        attrs: {
                          download: _vm.zipDownloadFile.file_name,
                          href: _vm.zipDownloadFile.file_path,
                          target: "_blank",
                        },
                      },
                      [_vm._v(_vm._s(_vm.zipDownloadFile.file_name))]
                    ),
                  ])
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "close-button",
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.onCloseDialog()
                },
              },
            },
            [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }